import { useState } from "react";
import { Dropdown,  } from "react-bootstrap";

import { ReactComponent as CalendarWeek } from "assets/svg/calendar-week.svg";

import CustomDropdownToggle from "components/common/CustomDropdownToggle";
import CustomDropdownMenu from "components/common/CustomDropdownMenu";

import { getReportPeriodTypeString } from "./utils/reportString";

import { ReportTimeRangeType } from "types/Reports";

type ReportTimeTypePickerProps = {
    timeRangeType: ReportTimeRangeType;
    handleTimeRangeTypeChange: (value: ReportTimeRangeType) => void;
};

export default function ReportTimeTypePicker({
    timeRangeType,
    handleTimeRangeTypeChange,
}: Readonly<ReportTimeTypePickerProps>) {
    const [open, setOpen] = useState<boolean>(false);

    const onOpen = () => {
        setOpen(!open);
    };

    const onChangeToAllDays = () => {
        handleTimeRangeTypeChange('all');
    };

    const onChangeToWeekdays = () => {
        handleTimeRangeTypeChange('weekdays');
    };

    const onChangeToWeekends = () => {
        handleTimeRangeTypeChange('weekends');
    };

    return (
        <div className="report-time-type-picker">
            <p className="report-time-type-picker-title">Day Type</p>
            <Dropdown show={open} onToggle={onOpen} className="text-right report-time-type-picker-dropdown">
                <CustomDropdownToggle
                    className='report-time-type-picker-toggle'
                    data-testid="report-time-type-picker-toggle"
                >
                    <CalendarWeek width="16px" height="16px" />
                    <div className="d-flex flex-row justify-content-between">
                        <span>{getReportPeriodTypeString(timeRangeType)}</span>
                        <i className="material-icons down ml-2">
                            keyboard_arrow_down
                        </i>
                    </div>
                </CustomDropdownToggle>
                <CustomDropdownMenu className="report-time-type-picker-menu">
                    <Dropdown.Item onClick={onChangeToAllDays}>{getReportPeriodTypeString('all')}</Dropdown.Item>
                    <Dropdown.Item onClick={onChangeToWeekdays}>{getReportPeriodTypeString('weekdays')}</Dropdown.Item>
                    <Dropdown.Item onClick={onChangeToWeekends}>{getReportPeriodTypeString('weekends')}</Dropdown.Item>
                </CustomDropdownMenu>
            </Dropdown>
        </div>
    );
}
